import * as React from 'react';

import { useTabletKeyboardGuard } from '@/hooks/use-tablet-keyboard-guard';

import { cn } from '@/lib/utils';

export type InputProps = React.ComponentProps<'input'> & {
  /** When false, allows programmatic focus (e.g. barcode scanner fields). Default true. */
  tabletKeyboardGuard?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, tabletKeyboardGuard = true, ...props }, ref) => {
    const { mergeFieldProps } = useTabletKeyboardGuard<HTMLInputElement>();
    const fieldProps = tabletKeyboardGuard ? mergeFieldProps(props) : props;

    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-semibold file:text-foreground placeholder:text-neutral-400 focus-visible:border-primary focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        ref={ref}
        {...fieldProps}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
